<template>
    <ul class="pagination-pages">
        <li v-for="(number, index) in pages"
            v-bind:key="index"
            :class="{ active: active === index }">
            <a @click="onPageClick(index)">{{ number }}</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Pagination',
    props: [
        'pages',
        'active',
    ],
    methods: {
        onPageClick(pageIndex) {
            this.$emit('page-change', pageIndex);
        }
    }
}
</script>
